import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isProductPerformanceEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isProductPerformanceEnabled>[0];
  isLoading: boolean;
}>;

export default function ProductPerformanceRouteGate({ user, isLoading, children }: Props) {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isProductPerformanceEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
